module.exports = __webpack_public_path__ + "static/desktop-stepper-gold-icon-6bd84211ea2d5c5082fde583c4390df5.svg";